<template>
    <div class="table-layout table-patient table-clinical">
        <div class="matrix-panel">
            <div class="table-layout table-patient table-clinical">
                <div class="table-head head-fixed">
                    <div class="table-tr">
                        <div class="table-th cell-availability-th">{{ __('Cancelled date') }}</div>
                        <div class="table-th cell-availability-th">{{ __('Replacement date') }}</div>
                        <div class="table-th cell-availability-th">{{ __('Duration') }}</div>
                    </div>
                </div>

                <div class="table-body">
                    <template v-for="(item, i) in items">
                        <HistoryListAvailabilityRow v-if="item.type === 'availability_changes'" :key="i" :item="item" :type="type" />
                        <HistoryListVacationRow v-if="item.type === 'vacations'" :key="i" :item="item" :type="type" />
                        <HistoryListSubstituteRow v-if="item.type === 'substitutes'" :key="i" :item="item" :type="type" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HistoryListAvailabilityRow from './HistoryListAvailabilityRow'
import HistoryListVacationRow from './HistoryListVacationRow'
import HistoryListSubstituteRow from './HistoryListSubstituteRow'

export default {
    components: {
        HistoryListAvailabilityRow,
        HistoryListVacationRow,
        HistoryListSubstituteRow
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    }
}
</script>
